/* SIDONIA · Filtros de colecciones y búsqueda (snippets/sidonia-filters.liquid).
   Funcionan en el navegador, sin configurar filtros en Shopify: la página trae todos los anuncios de la colección
   (hasta 250) y aquí se filtran, se cuentan y se ordenan al momento.

   - Datos de cada anuncio: los metacampos custom.* si existen; si no, se deducen del título, las etiquetas y unos
     trozos de la descripción con las mismas reglas que tools/shopify/preparar-descripciones.py (repo de Sidonia).
   - «Filtros» abre la ventana; lo que se elige no se aplica hasta «Ver N anuncios» (la «×», Esc o pulsar fuera
     cierran sin cambiar nada). Las opciones que no darían ningún anuncio se esconden.
   - Se ven los anuncios de 24 en 24 (el ajuste «Productos por página») con «Ver más anuncios».
   - Los filtros y el orden quedan en la dirección: ?tipo=Coupé&marca=Porsche&anio=1980-2000&orden=precio-asc */
(() => {
  if (window.customElements.get('sidonia-filters')) return;

  /* ------------------------------------------------------------------ Reglas (como preparar-descripciones.py) */
  // \b de JavaScript solo entiende letras sin tilde: se cambia por un límite de palabra que sí las entiende, sin
  // «lookbehind» (los iPhone con iOS anterior a 16.4 no lo tienen). Un \b al empezar una palabra (al principio, o tras
  // «(», «|» o «*») pide principio de texto o algo que no sea letra; uno al acabarla, que no siga una letra.
  const rx = (src, flags = '') => {
    const out = src.replace(/\\b/g, (m, i) => (i === 0 || '(|*'.includes(src[i - 1]) ? '(?:^|[^\\p{L}\\p{N}_])' : '(?![\\p{L}\\p{N}_])'));
    return new RegExp(out, `u${flags}`);
  };
  const firstMatch = (rules, text) => {
    for (const [name, re] of rules) if (re.test(text)) return name;
    return '';
  };

  const CLASE_COCHE = [
    ['4x4', rx(String.raw`\b(DEFENDER|SANTANA|SERIE I{1,3}|LAND ROVER (88|109|110)|RANGE ROVER|LAND CRUISER|[BFH]J ?\d\d|WRANGLER|WILLYS|CJ-?\d|CHEROKEE|COMM?ANDO|CLASE G|G-?CLASS|G ?(55|63|500)|\d{3} ?GD|NIVA|MASSIF|PATROL|PAJERO|DISCOVERY|BRONCO|SAMURAI|UNIMOG|4X4)\b`)],
    ['SUV', rx(String.raw`\b(CAYENNE|MACAN|X[3-7]|ESCALADE|ML ?\d{3}|GL[ESC]|Q[357]|TOUAREG|URUS|BENTAYGA|TAHOE|EVOQUE|VELAR)\b`)],
    ['Pick-up', rx(String.raw`\b(PICK-?UP|RAM|F-?\d{3}|HILUX|NAVARA|L200|SILVERADO|TUNDRA)\b`)],
    ['Furgoneta y camper', rx(String.raw`\b(KOMBI|WESTFALIA|CARAVELLE|CALIFORNIA|MULTIVAN|TRANSPORTER|T[1-6]|BULLI|CAMPER|FURGONETA|VAN)\b`)]
  ];
  const PALABRAS_COCHE = [
    ['Descapotable', rx(String.raw`\b(CABRIO\w*|CONVERTIBLE|DESCAPOTABLE|SPYDER|SPIDER|ROADSTER|TARGA|SPEEDSTER|VOLANTE|BARCHETTA)\b`)],
    ['Coupé', rx(String.raw`\b(COUP[EÉ])\b`)],
    ['Familiar', rx(String.raw`\b(AVANT|TOURING|ESTATE|BREAK|VARIANT|SHOOTING BRAKE|SPORTWAGON|FAMILIAR)\b|^MERCEDES.*\b\d{3} ?T[DE]?\b`)]
  ];
  const MODELOS_COCHE = [
    ['Descapotable', rx(String.raw`\b(BOXSTER|986|987|SPITFIRE|TR[2-8]A?|COBRA|ELISE|EXIGE|ELAN|914(\/\d)?|MX-?5|MIATA|SLK|Z4|STAG|\d{3} ?SL|SL ?\d{3})\b`)],
    ['Coupé', rx(String.raw`\b((911|912|930|964|993|996|997|991|992|924|928|944|968)\w*|CAYMAN|TESTAROSSA|VANTAGE|DB\d+|XJ-?S|XJR-S|F-TYPE|SUPRA|DELOREAN|FULVIA|PUMA|M[2346]|CLK|CL ?\d{3}|MUSTANG|CAMARO|CORVETTE|Z3|NSX|GT6)\b`)],
    ['Compacto', rx(String.raw`\b(MINI|GOLF|CLIO|YARIS|A35|A45|POLO|IBIZA|FIESTA|CORSA|R5|205|PANDA)\b`)],
    ['Berlina', rx(String.raw`\b(XJ\w*|SOVEREIGN|RAPIDE|REVERO|M5|E(12|21|23|28|30|32|34|36|38|39)|2002\w*|BEETLE|ESCARABAJO|[1-6]\d0 ?(S|SE|SEL|SEB|D|E)?|S ?\d{3}|E ?\d{3})\b`)]
  ];
  const CLASE_CASA = [
    ['Ático', rx('[aá]tico', 'i')], ['Piso', rx(String.raw`\b(piso|apartamento|d[uú]plex)\b`, 'i')], ['Chalet', rx(String.raw`\bchalet`, 'i')],
    ['Finca', rx(String.raw`\b(finca|cortijo|mas[ií]a|caser[ií]o|casa de campo|hacienda)\b`, 'i')], ['Villa', rx(String.raw`\bvilla\b`, 'i')],
    ['Casa', rx(String.raw`\bcasa\b`, 'i')]
  ];
  const CASA = rx(String.raw`\b(chalet|casa|villa|finca|piso|apartamento|[aá]tico|cortijo|mas[ií]a|caser[ií]o)\b`, 'i');
  const VELERO_TITULO = rx(String.raw`\b(velero|sloop|ketch|swan|hallberg|oyster|nauticat)`, 'i');
  const DIESEL = rx(String.raw`(\b\d{3}G?D\b|\bTD\d?\b|\d\.\dTD\b|\bTDV\d\b|\bTDI\b|\bCDI\b|\bDSE\b|\bHDI\b|\bJTD\b|\bDCI\b|DI[EÉ]SEL|GAS[OÓ]LEO)`, 'i');

  const MARCAS_COMPUESTAS = [
    ['LAND CRUISER', 'Toyota'], ['LAND ROVER', 'Land Rover'], ['RANGE ROVER', 'Land Rover'], ['ASTON MARTIN', 'Aston Martin'],
    ['ALFA ROMEO', 'Alfa Romeo'], ['ROLLS ROYCE', 'Rolls-Royce'], ['ROLLS-ROYCE', 'Rolls-Royce'], ['MERCEDES-BENZ', 'Mercedes-Benz'],
    ['MERCEDES-AMG', 'Mercedes-Benz'], ['MERCEDES', 'Mercedes-Benz'], ['DMC', 'DeLorean'], ['VW', 'Volkswagen'], ['AUSTIN HEALEY', 'Austin-Healey']
  ];
  const SIGLAS = new Set(['BMW', 'MG', 'AC', 'AMG', 'GMC', 'TVR', 'NSU', 'DS', 'SEAT']);
  const MARCAS_MOTO = new Set(['Yamaha', 'Ducati', 'Harley-Davidson', 'Kawasaki', 'Vespa', 'Bultaco', 'Montesa', 'Ossa', 'Derbi', 'Suzuki']);
  const PROVINCIAS = {
    madrid: 'Madrid', majadahonda: 'Madrid', pozuelo: 'Madrid', aranjuez: 'Madrid', alcobendas: 'Madrid', 'las rozas': 'Madrid',
    boadilla: 'Madrid', barcelona: 'Barcelona', sitges: 'Barcelona', bilbao: 'Vizcaya', vizcaya: 'Vizcaya', bizkaia: 'Vizcaya',
    valencia: 'Valencia', sevilla: 'Sevilla', 'málaga': 'Málaga', malaga: 'Málaga', marbella: 'Málaga', mijas: 'Málaga',
    'ojén': 'Málaga', butibamba: 'Málaga', ibiza: 'Islas Baleares', mallorca: 'Islas Baleares', menorca: 'Islas Baleares',
    baleares: 'Islas Baleares', sotogrande: 'Cádiz', conil: 'Cádiz', 'cádiz': 'Cádiz', 'puerto de santa maría': 'Cádiz',
    jerez: 'Cádiz', toledo: 'Toledo', consuegra: 'Toledo', tarragona: 'Tarragona', santander: 'Cantabria', liencres: 'Cantabria',
    cantabria: 'Cantabria', pamplona: 'Navarra', navarra: 'Navarra', 'ávila': 'Ávila', avila: 'Ávila',
    tenerife: 'Santa Cruz de Tenerife', segovia: 'Segovia', valladolid: 'Valladolid', 'la rioja': 'La Rioja', 'logroño': 'La Rioja',
    'gijón': 'Asturias', oviedo: 'Asturias', asturias: 'Asturias', 'san sebastián': 'Guipúzcoa', donostia: 'Guipúzcoa',
    lloret: 'Girona', girona: 'Girona', gerona: 'Girona', zaragoza: 'Zaragoza', alicante: 'Alicante', murcia: 'Murcia',
    granada: 'Granada', 'córdoba': 'Córdoba', salamanca: 'Salamanca', burgos: 'Burgos', 'león': 'León', 'a coruña': 'A Coruña',
    pontevedra: 'Pontevedra', vigo: 'Pontevedra', 'las palmas': 'Las Palmas', 'gran canaria': 'Las Palmas', lanzarote: 'Las Palmas'
  };

  // Valor de una línea de la ficha: lo que va detrás de «Clave:» (o la línea entera si no lleva clave)
  const line = (s) => {
    const t = String(s || '').split('¶')[0];
    const i = t.indexOf(':');
    return (i >= 0 ? t.slice(i + 1) : t).trim();
  };
  const str = (v) => (Array.isArray(v) ? v[0] : v) ?? '';

  function marcaDe(title) {
    const t = title.toUpperCase().trim();
    for (const [prefix, brand] of MARCAS_COMPUESTAS) if (t === prefix || t.startsWith(`${prefix} `)) return brand;
    const word = t.split(/\s+/)[0] || '';
    if (!word || word.startsWith('COLECCI')) return '';
    if (SIGLAS.has(word)) return word;
    return word.toLowerCase().split('-').map((x) => x.charAt(0).toUpperCase() + x.slice(1)).join('-');
  }

  function provinciaDe(text) {
    const low = (text || '').toLowerCase();
    let best = null;
    for (const [place, prov] of Object.entries(PROVINCIAS)) {
      const i = low.indexOf(place);
      if (i >= 0 && (!best || i < best[0])) best = [i, prov];
    }
    return best ? best[1] : '';
  }

  function kilometros(snippet) {
    const s = line(snippet);
    const m = s.match(/(\d{1,3}(?:[.\s]\d{3})+|\d+)/);
    if (!m) return null;
    let km = parseInt(m[1].replace(/\D/g, ''), 10);
    if (/milla|miles/i.test(s)) km = Math.round(km * 1.609);
    return km;
  }

  // Tramos de los metacampos custom.kilometros: se usa el punto medio
  function kmDeTramo(value) {
    const nums = String(value).replace(/\./g, '').match(/\d+/g);
    if (!nums) return null;
    if (/menos/i.test(value)) return Number(nums[0]) / 2;
    if (/más|mas/i.test(value)) return Number(nums[0]) + 25000;
    return nums.length > 1 ? (Number(nums[0]) + Number(nums[1])) / 2 : Number(nums[0]);
  }

  function combustible(title, snippet, motor, tipo) {
    const dato = line(snippet).toLowerCase();
    if (/h[ií]brid|mhev/.test(dato)) return 'Híbrido';
    if (/el[eé]ctric/.test(dato)) return 'Eléctrico';
    if (/di[eé]sel|gas[oó]leo/.test(dato)) return 'Diésel';
    if (/gasolina/.test(dato)) return 'Gasolina';
    if (/glp/.test(dato)) return 'GLP';
    if (DIESEL.test(`${title} ${motor || ''}`)) return 'Diésel';
    // Sin dato: los clásicos y deportivos son de gasolina; en 4x4, SUV, pick-up y furgonetas no se puede saber
    if (['4x4', 'SUV', 'Pick-up', 'Furgoneta y camper', ''].includes(tipo)) return '';
    return 'Gasolina';
  }

  function tipoCoche(title, item, tags) {
    const t = title.toUpperCase();
    if (t.startsWith('COLECCI')) return '';
    const flags = item.w || '';
    return firstMatch(CLASE_COCHE, t)
      || firstMatch(PALABRAS_COCHE, `${t} ${line(item.ca).toUpperCase()}`)
      || (tags.some((x) => x.includes('4X4')) ? '4x4' : '')
      || (flags.includes('D') ? 'Descapotable' : flags.includes('C') ? 'Coupé' : flags.includes('B') ? 'Berlina' : '')
      || firstMatch(MODELOS_COCHE, t);
  }

  // Para buscar: minúsculas y sin tildes
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Un anuncio de la página -> los valores por los que se filtra
  function describe(item, index) {
    const mf = item.mf || {};
    const title = item.t || '';
    const tags = (item.g || '').toUpperCase().split('|').map((x) => x.trim());
    const flags = item.w || '';
    let categoria = 'Coche';
    if (tags.includes('BARCOS') || tags.includes('BARCO') || /embarcaci|barco/i.test(item.ty || '')) categoria = 'Barco';
    else if (CASA.test(title)) categoria = 'Casa';

    let marca = str(mf.marca) || (categoria === 'Casa' ? '' : marcaDe(title));
    if (MARCAS_MOTO.has(marca)) categoria = 'Moto';

    let tipo = str(mf.tipo);
    let km = null;
    let fuel = str(mf.combustible);
    if (!tipo) {
      if (categoria === 'Casa') tipo = firstMatch(CLASE_CASA, `${line(item.ti)} ${title}`) || 'Casa';
      else if (categoria === 'Barco') {
        const eslora = parseFloat(line(item.es).replace(/^[^\d]*/, '').replace(/\./g, '').replace(',', '.')) || 0;
        tipo = flags.includes('V') || VELERO_TITULO.test(title) ? 'Velero' : flags.includes('N') ? 'Neumática' : flags.includes('L') ? 'Llaüt' : eslora >= 12 ? 'Yate' : 'Lancha';
      } else if (categoria === 'Moto') tipo = 'Moto';
      else tipo = tipoCoche(title, item, tags);
    }
    if (categoria === 'Coche' || categoria === 'Moto') {
      km = mf.kilometros ? kmDeTramo(str(mf.kilometros)) : kilometros(item.km) ?? kilometros(item.kmn);
      if (!fuel) fuel = combustible(title, item.fu, item.mo, categoria === 'Moto' ? 'Moto' : tipo);
    }

    let ano = parseInt(str(mf.ano), 10) || null;
    if (!ano) {
      const m = line(item.an).match(/\b(19\d\d|20\d\d)\b/);
      if (m) ano = Number(m[1]);
    }
    if (!ano) {
      const all = title.match(/\b(19\d\d|20[0-2]\d)\b/g);
      if (all) ano = Number(all[all.length - 1]);
    }

    const provincia = str(mf.provincia) || provinciaDe(item.lo);

    let estado = item.a ? 'Disponible' : 'Vendido';
    if (tags.includes('VENDIDO')) estado = 'Vendido';
    else if (tags.includes('RESERVADO')) estado = 'Reservado';

    return {
      handle: item.h, index, title, date: Number(item.d) || 0, dueno: tags.includes('DUENO'),
      // Lo que se busca con «Buscar» (?q=): título, etiquetas, tipo, marca y la ficha
      texto: norm([title, item.g, item.ty, marca, mf.marca, mf.ano, item.mo, item.ca].join(' ')), vende: tags.includes('DUENO') ? 'Sus dueños' : 'Sidonia',
      tipo, marca, ano, km, combustible: fuel, provincia, estado,
      precio: item.p > 0 ? item.p / 100 : null,
      oferta: item.p > 0 && item.c > item.p && estado === 'Disponible' ? 'Ha bajado de precio' : null
    };
  }

  /* ------------------------------------------------------------------ Grupos de la ventana */
  const PRICE_STEPS = [5000, 10000, 15000, 20000, 30000, 40000, 50000, 75000, 100000, 150000, 200000, 300000, 500000, 750000, 1000000, 2000000, 5000000];
  const KM_STEPS = [10000, 25000, 50000, 75000, 100000, 150000, 200000, 300000];
  const fmtNum = (n) => Math.round(n).toLocaleString('es-ES');
  const euros = (n) => `${fmtNum(n)} €`;
  const GROUPS = [
    { key: 'tipo', label: 'Tipo', kind: 'list', param: 'tipo' },
    { key: 'vende', label: 'Quién lo vende', kind: 'list', param: 'vende', order: ['Sidonia', 'Sus dueños'] },
    { key: 'marca', label: 'Marca', kind: 'list', param: 'marca' },
    { key: 'ano', label: 'Año', kind: 'range', param: 'anio', fmt: String, chip: (a, b) => (a && b ? (a === b ? `Año ${a}` : `${a} – ${b}`) : a ? `Desde ${a}` : `Hasta ${b}`) },
    { key: 'precio', label: 'Precio', kind: 'range', param: 'precio', steps: PRICE_STEPS, fmt: euros, chip: (a, b) => (a && b ? `${euros(a)} – ${euros(b)}` : a ? `Desde ${euros(a)}` : `Hasta ${euros(b)}`) },
    { key: 'oferta', label: 'Ofertas', kind: 'list', param: 'oferta', min: 1 },
    { key: 'km', label: 'Kilómetros', kind: 'range', param: 'km', steps: KM_STEPS, fmt: (n) => `${fmtNum(n)} km`, chip: (a, b) => (a && b ? `${fmtNum(a)} – ${fmtNum(b)} km` : a ? `Desde ${fmtNum(a)} km` : `Hasta ${fmtNum(b)} km`) },
    { key: 'combustible', label: 'Combustible', kind: 'list', param: 'combustible' },
    { key: 'provincia', label: 'Localización', kind: 'list', param: 'localizacion' },
    { key: 'estado', label: 'Estado', kind: 'list', param: 'estado', order: ['Disponible', 'Reservado', 'Vendido'] }
  ];
  const SORTS = {
    destacados: (a, b) => a.index - b.index,
    relevancia: (a, b) => a.index - b.index,
    recientes: (a, b) => b.date - a.date || a.index - b.index,
    'precio-asc': (a, b) => (a.precio ?? Infinity) - (b.precio ?? Infinity) || a.index - b.index,
    'precio-desc': (a, b) => (b.precio ?? -Infinity) - (a.precio ?? -Infinity) || a.index - b.index,
    'anio-desc': (a, b) => (b.ano ?? -Infinity) - (a.ano ?? -Infinity) || a.index - b.index,
    'anio-asc': (a, b) => (a.ano ?? Infinity) - (b.ano ?? Infinity) || a.index - b.index
  };

  const emptySel = () => Object.fromEntries(GROUPS.map((g) => [g.key, g.kind === 'list' ? [] : { from: null, to: null }]));
  const cloneSel = (sel) => JSON.parse(JSON.stringify(sel));
  const isActive = (g, s) => (g.kind === 'list' ? s.length > 0 : s.from != null || s.to != null);

  function passes(g, item, s) {
    if (!isActive(g, s)) return true;
    const v = item[g.key];
    if (g.kind === 'list') return s.includes(v);
    if (v == null) return false;
    return (s.from == null || v >= s.from) && (s.to == null || v <= s.to);
  }

  const plural = (n) => (n === 1 ? '1 anuncio' : `${n.toLocaleString('es-ES')} anuncios`);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const X_ICON = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  class SidoniaFilters extends HTMLElement {
    connectedCallback() {
      let raw = [];
      try { raw = JSON.parse(this.querySelector('[data-sf-data]').textContent); } catch (e) { return; }
      this.items = raw.map(describe);
      // Como en la cuadrícula: primero los anuncios de Sidonia (gestión de venta), después los de sus dueños y los
      // vendidos siempre al final
      {
        const vendido = (i) => i.estado === 'Vendido';
        const primero = this.hasAttribute('data-sidonia-first');
        const disp = this.items.filter((i) => !vendido(i));
        this.items = [...(primero ? [...disp.filter((i) => !i.dueno), ...disp.filter((i) => i.dueno)] : disp), ...this.items.filter(vendido)];
        this.items.forEach((i, n) => { i.index = n; });
      }
      this.section = this.closest('.shopify-section') || document;
      this.list = this.section.querySelector('product-list');
      if (!this.list) return;
      this.cards = new Map();
      this.list.querySelectorAll(':scope > [handle]').forEach((el) => this.cards.set(el.getAttribute('handle'), el));
      this.original = [...this.list.children];
      this.promos = this.original.filter((el) => !el.hasAttribute('handle'));
      this.perPage = parseInt(this.dataset.perPage, 10) || 24;
      this.defaultSort = this.dataset.defaultSort || 'destacados';

      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-sf-body]');
      this.applyBtn = this.querySelector('[data-sf-apply]');
      this.sortSel = this.querySelector('[data-sf-sort]');
      this.countEl = this.querySelector('[data-sf-count]');
      this.chipsEl = this.querySelector('[data-sf-chips]');
      this.badge = this.querySelector('[data-sf-badge]');
      this.floatBtn = this.querySelector('[data-sf-float]');
      this.floatLabel = this.querySelector('[data-sf-float-label]');

      // Valores que existen en esta colección (los grupos con menos de dos no se enseñan)
      this.values = {};
      for (const g of GROUPS) {
        const set = new Set(this.items.map((i) => i[g.key]).filter((v) => v !== '' && v != null));
        let vals = [...set];
        if (g.order) vals.sort((a, b) => g.order.indexOf(a) - g.order.indexOf(b));
        else if (g.kind === 'list') vals.sort((a, b) => String(a).localeCompare(String(b), 'es', { sensitivity: 'base', numeric: true }));
        else vals.sort((a, b) => a - b);
        this.values[g.key] = vals;
      }
      this.groups = GROUPS.filter((g) => this.values[g.key].length >= (g.min || 2));

      this.readUrl();
      this.page = 1;

      if (this.sortSel) {
        if (![...this.sortSel.options].some((o) => o.value === this.sort)) this.sort = this.defaultSort;
        this.sortSel.value = this.sort;
        this.sortSel.addEventListener('change', () => {
          this.sort = this.sortSel.value;
          this.page = 1;
          this.render(true);
        });
      }

      const canFilter = !this.hasAttribute('data-no-filters') && this.groups.length > 0 && this.dialog;
      this.querySelectorAll('[data-sf-open]').forEach((b) => {
        b.hidden = !canFilter;
        b.addEventListener('click', () => this.open());
      });
      if (canFilter) {
        this.querySelector('[data-sf-close]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-sf-reset]').addEventListener('click', () => { this.draft = emptySel(); this.renderDialog(); });
        this.dialog.addEventListener('close', () => document.documentElement.classList.remove('sidonia-filters-lock'));
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        });
        this.body.addEventListener('change', (event) => this.onDraftChange(event));
        this.querySelector('[data-sf-form]').addEventListener('submit', (event) => {
          event.preventDefault();
          this.sel = cloneSel(this.draft);
          this.page = 1;
          this.dialog.close();
          this.render(true);
        });
      }

      this.chipsEl.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-chip]');
        if (!chip) return;
        const g = GROUPS.find((x) => x.key === chip.dataset.chip);
        if (chip.dataset.chip === 'q') this.q = '';
        else if (!g) { this.sel = emptySel(); this.q = ''; }
        else if (g.kind === 'list') this.sel[g.key] = this.sel[g.key].filter((v) => v !== chip.dataset.value);
        else this.sel[g.key] = { from: null, to: null };
        this.page = 1;
        this.render(true);
      });

      // «Ver más anuncios» y aviso de «no hay anuncios»
      this.more = document.createElement('div');
      this.more.className = 'sidonia-filters__more';
      this.more.innerHTML = '<button type="button" class="sidonia-filters__more-btn"></button>';
      this.more.firstElementChild.addEventListener('click', () => { this.page += 1; this.render(false); });
      this.empty = document.createElement('div');
      this.empty.className = 'sidonia-filters__empty';
      this.empty.innerHTML = '<p>No hay anuncios con estos filtros.</p><button type="button" class="sidonia-filters__btn">Borrar filtros</button>';
      this.empty.querySelector('button').addEventListener('click', () => { this.sel = emptySel(); this.q = ''; this.page = 1; this.render(true); });
      // «A la carta»: lo que se estaba buscando viaja al formulario, ya rellenado
      if (this.dataset.cartaUrl) {
        const carta = document.createElement('a');
        carta.className = 'sidonia-filters__carta';
        carta.href = this.dataset.cartaUrl;
        carta.innerHTML = '<strong>¿No lo encuentras?</strong> Dinos qué buscas y te lo encontramos <span aria-hidden="true">→</span>';
        carta.addEventListener('click', () => {
          const url = new URL(this.dataset.cartaUrl, location.origin);
          const q = new URLSearchParams(location.search);
          ['tipo', 'marca', 'anio', 'precio', 'combustible', 'localizacion'].forEach((k) => { if (q.get(k)) url.searchParams.set(k, q.get(k)); });
          if (this.dataset.cartaQue) url.searchParams.set('que', this.dataset.cartaQue);
          url.searchParams.set('desde', location.pathname);
          carta.href = url.pathname + url.search;
        });
        this.empty.append(carta);
      }
      this.list.after(this.more, this.empty);
      this.list.setAttribute('data-sf-ready', '');

      if (this.floatBtn && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          const above = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.floatBtn.classList.toggle('is-visible', above);
          this.floatBtn.tabIndex = above ? 0 : -1;
        });
        this.observer.observe(this.querySelector('[data-sf-bar]'));
      }

      this.render(false);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.documentElement.classList.remove('sidonia-filters-lock');
    }

    /* ---------------------------------------------------------------- Estado en la dirección */
    readUrl() {
      const q = new URLSearchParams(location.search);
      this.sel = emptySel();
      for (const g of GROUPS) {
        const raw = q.get(g.param);
        if (!raw) continue;
        if (g.kind === 'list') {
          this.sel[g.key] = raw.split(',').map((v) => v.trim()).filter(Boolean);
        } else {
          const [a, b] = raw.split('-');
          this.sel[g.key] = { from: a ? Number(a) : null, to: b ? Number(b) : null };
        }
      }
      this.sort = q.get('orden') || this.defaultSort;
      this.q = (q.get('q') || '').trim().slice(0, 80);
    }

    writeUrl() {
      const url = new URL(location.href);
      for (const g of GROUPS) url.searchParams.delete(g.param);
      ['orden', 'page', 'sort_by'].forEach((k) => url.searchParams.delete(k));
      for (const g of GROUPS) {
        const s = this.sel[g.key];
        if (!isActive(g, s)) continue;
        url.searchParams.set(g.param, g.kind === 'list' ? s.join(',') : `${s.from ?? ''}-${s.to ?? ''}`);
      }
      if (this.sort !== this.defaultSort) url.searchParams.set('orden', this.sort);
      if (this.q) url.searchParams.set('q', this.q); else url.searchParams.delete('q');
      history.replaceState(history.state, '', url.toString());
    }

    /* ---------------------------------------------------------------- Resultados */
    matching(sel, skipKey) {
      // «Buscar»: todas las palabras tienen que estar (944 encuentra también «944 S2» y «944S2»)
      const palabras = norm(this.q).split(/\s+/).filter(Boolean);
      return this.items.filter((item) => GROUPS.every((g) => g.key === skipKey || passes(g, item, sel[g.key])) && palabras.every((w) => item.texto.includes(w)));
    }

    render(changed) {
      // Los vendidos, al final con cualquier orden
      const orden = SORTS[this.sort] || SORTS.destacados;
      const matches = this.matching(this.sel).sort((a, b) => (a.estado === 'Vendido') - (b.estado === 'Vendido') || orden(a, b));
      const shown = matches.slice(0, this.page * this.perPage);
      const shownSet = new Set(shown.map((i) => i.handle));
      const plain = !this.q && !GROUPS.some((g) => isActive(g, this.sel[g.key])) && SORTS[this.sort] === SORTS[this.defaultSort];

      // Ordena las tarjetas (las que no entran se esconden y van al final)
      const frag = document.createDocumentFragment();
      if (plain) {
        // Sin filtros ni orden: todo en su sitio, con los bloques de promoción entre las tarjetas que se ven
        let cardsBefore = 0;
        for (const el of this.original) {
          if (el.hasAttribute('handle')) {
            el.hidden = !shownSet.has(el.getAttribute('handle'));
            cardsBefore += 1;
          } else {
            el.hidden = cardsBefore >= shown.length;
          }
          frag.appendChild(el);
        }
      } else {
        for (const item of matches) {
          const card = this.cards.get(item.handle);
          if (card) {
            card.hidden = !shownSet.has(item.handle);
            frag.appendChild(card);
          }
        }
        const matchSet = new Set(matches.map((i) => i.handle));
        for (const [handle, card] of this.cards) {
          if (!matchSet.has(handle)) {
            card.hidden = true;
            frag.appendChild(card);
          }
        }
        this.promos.forEach((p) => { p.hidden = true; frag.appendChild(p); });
      }
      this.list.appendChild(frag);
      // La animación de entrada de Impact (reveal-items) deja a medias, invisibles, las tarjetas que estaban ocultas
      // cuando se animó la cuadrícula: al enseñarlas se termina
      for (const card of this.list.children) {
        if (card.hidden) continue;
        card.getAnimations().forEach((a) => a.finish());
        if (getComputedStyle(card).opacity === '0') card.style.opacity = '1';
      }

      const rest = matches.length - shown.length;
      this.more.hidden = rest <= 0;
      this.more.firstElementChild.textContent = `Ver más anuncios (${rest.toLocaleString('es-ES')})`;
      this.empty.hidden = matches.length > 0;
      this.empty.firstElementChild.textContent = this.q ? `No hay anuncios con «${this.q}». Prueba con la marca o el modelo.` : 'No hay anuncios con estos filtros.';
      this.countEl.textContent = plural(matches.length);
      this.renderChips();
      if (changed) {
        this.writeUrl();
        if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    renderChips() {
      const chips = [];
      if (this.q) chips.push(`<button type="button" class="sidonia-filters__chip" data-chip="q" aria-label="Quitar la búsqueda">«${esc(this.q)}»${X_ICON}</button>`);
      for (const g of GROUPS) {
        const s = this.sel[g.key];
        if (!isActive(g, s)) continue;
        if (g.kind === 'list') {
          s.forEach((v) => chips.push(`<button type="button" class="sidonia-filters__chip" data-chip="${g.key}" data-value="${esc(v)}" aria-label="Quitar ${esc(v)}">${esc(v)}${X_ICON}</button>`));
        } else {
          chips.push(`<button type="button" class="sidonia-filters__chip" data-chip="${g.key}" aria-label="Quitar el filtro de ${g.label.toLowerCase()}">${esc(g.chip(s.from, s.to))}${X_ICON}</button>`);
        }
      }
      if (chips.length) chips.push('<button type="button" class="sidonia-filters__clear" data-chip="todo">Borrar filtros</button>');
      this.chipsEl.innerHTML = chips.join('');
      this.chipsEl.hidden = chips.length === 0;
      const n = GROUPS.reduce((acc, g) => acc + (g.kind === 'list' ? this.sel[g.key].length : isActive(g, this.sel[g.key]) ? 1 : 0), 0);
      if (this.badge) {
        this.badge.hidden = n === 0;
        this.badge.textContent = n;
      }
      if (this.floatLabel) this.floatLabel.textContent = n ? `Filtros · ${n}` : 'Filtros';
    }

    /* ---------------------------------------------------------------- Ventana */
    open() {
      if (!this.dialog) return;
      this.draft = cloneSel(this.sel);
      this.openGroups = new Set();
      this.renderDialog();
      this.dialog.showModal();
      this.body.scrollTop = 0;
      document.documentElement.classList.add('sidonia-filters-lock');
    }

    rangeOptions(g) {
      if (g.key === 'ano') return this.values.ano;
      const max = Math.max(...this.values[g.key]);
      const steps = g.steps.filter((s) => s < max);
      return steps.length ? steps : g.steps.slice(0, 1);
    }

    renderDialog() {
      const html = [];
      for (const g of this.groups) {
        const s = this.draft[g.key];
        // Cada grupo, desplegable: cerrado, con lo elegido al lado del nombre
        html.push(`<details class="sidonia-filters__group" data-group="${g.key}"${this.openGroups && this.openGroups.has(g.key) ? ' open' : ''}><summary class="sidonia-filters__legend"><span>${g.label}</span><span class="sidonia-filters__sum" data-sum>${esc(this.summary(g))}</span><svg class="sidonia-filters__chev" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></summary><div class="sidonia-filters__panel">`);
        if (g.kind === 'list') {
          const others = this.matching(this.draft, g.key);
          html.push('<div class="sidonia-filters__pills">');
          for (const v of this.values[g.key]) {
            const n = others.filter((i) => i[g.key] === v).length;
            const on = s.includes(v);
            html.push(`<label class="sidonia-filters__pill"${!n && !on ? ' hidden' : ''}><input type="checkbox" value="${esc(v)}"${on ? ' checked' : ''}><span>${esc(v)} <small>${n}</small></span></label>`);
          }
          html.push('</div>');
        } else {
          const opts = this.rangeOptions(g);
          const optList = (sel, anyFirst) => {
            const list = opts.map((v) => `<option value="${v}"${sel === v ? ' selected' : ''}>${g.fmt(v)}</option>`);
            if (sel != null && !opts.includes(sel)) list.push(`<option value="${sel}" selected>${g.fmt(sel)}</option>`);
            const any = `<option value=""${sel == null ? ' selected' : ''}>Cualquiera</option>`;
            return anyFirst ? any + list.join('') : list.join('') + any;
          };
          html.push(`<div class="sidonia-filters__range">
            <label><span>Desde</span><select data-from>${optList(s.from, true)}</select></label>
            <label><span>Hasta</span><select data-to>${optList(s.to, false)}</select></label>
          </div>`);
        }
        html.push('</div></details>');
      }
      this.body.innerHTML = html.join('');
      // Se recuerda qué grupos están abiertos mientras la ventana sigue abierta
      this.body.querySelectorAll('details[data-group]').forEach((d) => d.addEventListener('toggle', () => {
        this.openGroups = this.openGroups || new Set();
        if (d.open) this.openGroups.add(d.dataset.group); else this.openGroups.delete(d.dataset.group);
      }));
      this.updateApply();
    }

    // Lo elegido en un grupo, en corto: «BMW, Porsche +2» o «1960 – 1980»
    summary(g) {
      const s = this.draft[g.key];
      if (g.kind === 'list') {
        if (!s.length) return '';
        return s.length > 2 ? `${s.slice(0, 2).join(', ')} +${s.length - 2}` : s.join(', ');
      }
      if (s.from == null && s.to == null) return '';
      if (s.from != null && s.to != null) return `${g.fmt(s.from)} – ${g.fmt(s.to)}`;
      return s.from != null ? `Desde ${g.fmt(s.from)}` : `Hasta ${g.fmt(s.to)}`;
    }

    onDraftChange(event) {
      const group = event.target.closest('[data-group]');
      if (!group) return;
      const g = GROUPS.find((x) => x.key === group.dataset.group);
      if (g.kind === 'list') {
        this.draft[g.key] = [...group.querySelectorAll('input:checked')].map((i) => i.value);
      } else {
        const from = group.querySelector('[data-from]');
        const to = group.querySelector('[data-to]');
        let a = from.value === '' ? null : Number(from.value);
        let b = to.value === '' ? null : Number(to.value);
        if (a != null && b != null && a > b) {
          // «Desde» por encima de «Hasta»: se quita el otro extremo
          if (event.target === from) { b = null; to.value = ''; } else { a = null; from.value = ''; }
        }
        this.draft[g.key] = { from: a, to: b };
      }
      const sum = group.querySelector('[data-sum]');
      if (sum) sum.textContent = this.summary(g);
      this.refreshCounts();
    }

    // Números de cada opción y «Ver N anuncios» con lo que hay elegido en la ventana
    refreshCounts() {
      for (const g of this.groups) {
        if (g.kind !== 'list') continue;
        const others = this.matching(this.draft, g.key);
        this.body.querySelectorAll(`[data-group="${g.key}"] .sidonia-filters__pill`).forEach((pill) => {
          const input = pill.querySelector('input');
          const n = others.filter((i) => i[g.key] === input.value).length;
          pill.querySelector('small').textContent = n;
          pill.hidden = !n && !input.checked;
        });
      }
      this.updateApply();
    }

    updateApply() {
      const n = this.matching(this.draft).length;
      this.applyBtn.textContent = n === 0 ? 'Sin anuncios' : `Ver ${plural(n)}`;
      this.applyBtn.disabled = n === 0;
    }
  }

  window.customElements.define('sidonia-filters', SidoniaFilters);
})();
